export default __webpack_public_path__ + "static/broadcastImg4-4733483b3ef75e10daa39805059979bf.webp";